import { createIcon } from './create-icon'

export const SuccessO = createIcon({
  displayName: 'SuccessO',
  paths: [
    'M671.689 460.501l-168.533 168.533c-16.64 16.64-43.691 16.64-60.331 0l-90.496-90.539c-16.683-16.64-16.683-43.648 0-60.331 16.64-16.683 43.691-16.683 60.331 0l60.331 60.331 138.368-138.325c16.64-16.683 43.648-16.683 60.331 0 16.683 16.64 16.683 43.648 0 60.331zM511.987 170.667c-188.501 0-341.333 152.832-341.333 341.333s152.832 341.333 341.333 341.333c188.544 0 341.333-152.832 341.333-341.333s-152.789-341.333-341.333-341.333z'
  ]
})
